module.exports = __webpack_public_path__ + "static/media/logo-foreign-heco.336d2440.png";